<template>
    <section class="gmp-section gmp-mb-std">
        <div class="features-module">
            <div class="h-c-page">

                <div class="h-c-grid features-module__row">
                    <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 h-c-grid__col-l--order-1 features-module__content--left">
                        <h3 class="h-c-headline h-c-headline--one h-has-bottom-margin">
                            定价客户
                        </h3>
                        <p class="h-u-mb-std features-module__description">
                            企业供应链管理中的关键环节，通过多元化管理、评估与选择、关系维护和价格管控等手段，企业可以确保供应链的稳定性、降低成本并提升整体运营效率。
                        </p>
                    </div>

                    <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 h-c-grid__col-l--order-2 features-module__content--right">
                        <div class="glue-zippy-set h-t-hercules ng-scope glue-is-mixed">
                            <div class="glue-zippy-toggle-all" data-g-action="expand all2">
                                <span class="h-c-expansion-panels__toggle-text h-c-expansion-panels__toggle-text--expanded">
                               展开全部
                            </span>
                                <span class="h-c-expansion-panels__toggle-text h-c-expansion-panels__toggle-text--collapsed">
                                折叠全部
                            </span>
                                <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon h-c-icon--18px h-c-expansion-panels__toggle-circle" >
                                    <polyline points="0,0 4,4 8,0" style=" stroke:#177166; stroke-width:2" @click="expendAll(2)" />
                                </svg>
                            </div>

                            <ul class="h-c-expansion-panels__list">
                                <li class="glue-zippy glue-a-zippy--v-smooth-expand ng-isolate-scope glue-c-zippy ">
                                    <div class="glue-zippy-btn ng-isolate-scope glue-c-zippy__btn">
                                        <h4 class="h-c-expansion-panels__button-header">
                                            接单功能对接
                                        </h4>

                                        <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon--18px h-c-expansion-panels__button-arrow" @click="addExpend(1,2)">
                                            <polyline points="0,0 7,7 14,0" style="fill:white;stroke:#1a73e8;stroke-width:3" />
                                        </svg>

                                    </div>

                                    <div class="glue-zippy-content ng-isolate-scope glue-c-zippy__content">
                                        <div class="glue-c-zippy__collapse-region glue-collapse-expanded" id="zippy-1-content2">
                                            <div class="glue-c-zippy__content-container">
                                                <p class="ng-scope">
                                                    企业可以实现订单的实时传输和处理，确保供货商能够及时收到订单并开始准备发货。这大大缩短了订单处理时间，提高了供应链的响应速度。
                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </li>
                                <li class="glue-zippy glue-a-zippy--v-smooth-expand ng-isolate-scope glue-c-zippy ">
                                    <div class="glue-zippy-btn ng-isolate-scope glue-c-zippy__btn">
                                        <h4 class="h-c-expansion-panels__button-header">
                                            结账管理
                                        </h4>

                                        <svg xmlns="http://www.w3.org/2000/svg"   class="h-c-icon--18px h-c-expansion-panels__button-arrow" @click="addExpend(2,2)">
                                            <polyline points="0,0 7,7 14,0" style="fill:white;stroke:#1a73e8;stroke-width:3" />
                                        </svg>

                                    </div>

                                    <div class="glue-zippy-content ng-isolate-scope glue-c-zippy__content">
                                        <div class="glue-c-zippy__collapse-region glue-collapse-expanded" id="zippy-2-content2">
                                            <div class="glue-c-zippy__content-container">
                                                <p class="ng-scope">
                                                    企业可以自动生成结账单据和付款记录，减少人工操作，避免手动结账过程中可能出现的错误和遗漏，确保结账过程准确无误。
                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </li>

                            </ul>


                        </div>


                    </div>
                </div>




            </div>

        </div>


    </section>
</template>

<script>
    export default {
        name: "DIS_features_module_three",
        methods: {
            expendAll(index){

                console.log(index)
                var expend = this.$('.gmp-mb-std').eq(index).find(".glue-zippy-toggle-all").attr('data-g-action');
                var aaas =  this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow');
                if(expend === 'expand all'+index){
                    for(var i = 1; i < aaas.length +1 ; i++){
                        // this.$('.gmp-mb-std').eq(index).parent().parent().addClass('glue-is-expanded');
                        this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow').eq([i-1]).parent().parent().addClass('glue-is-expanded');

                        this.$('.gmp-mb-std').eq(index).find('#zippy-'+i +'-content'+index).css({
                            "max-height": "100%",
                        })
                    }
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-set').removeClass('glue-is-mixed').addClass('glue-is-expanded');
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-toggle-all').attr("data-g-action","collapse all")

                }else{
                    for(var j = 1; j < aaas.length +1 ; j++){
                        var aaa1 =  this.$('.gmp-mb-std').eq(index).find('.h-c-expansion-panels__button-arrow')[j-1];
                        this.$(aaa1).parent().parent().removeClass('glue-is-expanded');
                        this.$('#zippy-'+ j +'-content'+index).css({
                            "max-height": "0",
                        })
                    }
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-set').addClass('glue-is-mixed').removeClass('glue-is-expanded');
                    this.$('.gmp-mb-std').eq(index).find('.glue-zippy-toggle-all').attr("data-g-action","expand all")
                }
            },

            addExpend(index,which) {
                var aaa =  this.$('.gmp-mb-std').eq(which).find('.h-c-expansion-panels__button-arrow')[index-1];
                var fatherExpend = this.$('.gmp-mb-std').eq(which).find(aaa).parent().parent().is('.glue-is-expanded');
                if(fatherExpend){
                    this.$('.gmp-mb-std').eq(which).find('#zippy-'+index+'-content'+ which).css({
                        "max-height": "0",
                    })
                    this.$(aaa).parent().parent().removeClass('glue-is-expanded');
                    this.$('.glue-zippy-toggle-all').attr("data-g-action","expand all")
                    this.$('.glue-zippy-set').addClass('glue-is-mixed').removeClass('glue-is-expanded');

                }else{
                    this.$(aaa).parent().parent().addClass('glue-is-expanded');
                    this.$('#zippy-'+index+'-content' + which).css({
                        "max-height": "100%",
                    })
                }

            }


        },
    }
</script>

<style lang="less">


</style>